import fingerPrintInstance from "../storeInitializer/initialiseFingerprint";
import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import {
  collectData,
  createHash,
  getHashValue,
} from "../../helpers/fingerPrintHelper";

export default {
  namespaced: true,
  state: {
    fpInfo: {},
    hashKey: "",
  },
  mutations: {
    setHashKey(state, payload) {
      state.hashKey = payload.response;
    },
  },
  getters: {
    getFpInfoData: (state) => {
      return state.fpInfo;
    },
    getVerifyDeletedUser: (state) => {
      return state.verifyOtpInfo;
    },
  },
  actions: {
    sendFingerPrint({ commit, dispatch }, payload) {
      ApiCalls.FINGERPRINT_INFO({
        headers: Headers(),
        payload: payload,
      })
        .then(function (response) {
          if (response) {
            getHashValue({
              detectorData: payload.detectorData,
              response: response.data,
            }).then((result) => {
              commit("setHashKey", {
                response: { key: result, id: payload.detectorData.uid },
              });
            });
          }
        })
        .catch(function (error) {
          // console.log("sendFingerPrint error", error);
        })
        .finally(function () {
          // console.log("user otp executed");
        });
    },
  },
};
